<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableApprovalFlowConfigurationDate"
      style="width: 100.1%;"
    >
      <template slot-scope="{ row, index }" slot="detail">
        <Button
          type="success"
          size="small"
          v-hasPermission="[
            'approvalFlowConfiguration:approvalFlowConfiguration:log'
          ]"
          @click="rowClick(row)"
          >{{ $t("configuration_management.common.operationLog") }}</Button
        >
        <span @click="doUpdate(index)">
          <Button
            type="warning"
            size="small"
            @click="approvalFlowConfigurationEditModal = true"
            v-hasPermission="[
              'approvalFlowConfiguration:approvalFlowConfiguration:edit'
            ]"
            >{{
              $t("approvalFlowConfigManagement.approvalFlow.editButton")
            }}</Button
          >
        </span>
        <span @click="doDelete(index)">
          <Button
            type="error"
            size="small"
            @click="approvalFlowConfigurationDelmodal = true"
            v-hasPermission="[
              'approvalFlowConfiguration:approvalFlowConfiguration:delete'
            ]"
            >{{ $t("configuration_management.common.deleteButton") }}</Button
          >
        </span>
      </template>
    </Table>
    <!-- 操作日志详情 -->
    <configuration-management-operation-log
      v-if="isShowOperationLog"
      ref="configurationManagementOperationLog"
    ></configuration-management-operation-log>
    <!-- 删除模式框 -->
    <Modal
      v-model="approvalFlowConfigurationDelmodal"
      width="360"
      :mask-closable="false"
    >
      <p slot="header" style="color:#f60;text-align:center">
        <Icon type="ios-information-circle"></Icon>
        <span>{{ $t("alarms.common.deleteConfirmation") }}</span>
      </p>
      <div style="text-align:center">
        <p>{{ $t("alarms.common.sureDelete") }} {{ name }} ?</p>
      </div>
      <div slot="footer">
        <Button
          type="error"
          size="large"
          long
          :loading="modal_loading"
          @click="removeApprovalFlowConfiguration()"
          :disabled="isDisable"
          >{{ $t("ticket.list.delete") }}
        </Button>
      </div>
    </Modal>
    <Modal
      v-model="approvalFlowConfigurationEditModal"
      :title="$t('approvalFlowConfigManagement.approvalFlow.editApprovalFlow')"
      :loading="loading"
      :mask-closable="false"
      :styles="{ top: '65px' }"
      width="900px;"
      @on-ok="caseSubmit('approvalFlowConfigurationEditForm')"
      @on-cancel="caseReset('approvalFlowConfigurationEditForm')"
    >
      <Form
        ref="approvalFlowConfigurationEditForm"
        :model="approvalFlowConfigurationEditForm"
        :label-width="100"
        :rules="ruleValidate"
      >
        <Row>
          <Col span="12">
            <!-- 审批流名称 -->
            <FormItem
              :label="
                $t('approvalFlowConfigManagement.approvalFlow.approvalFlowName')
              "
              prop="processName"
            >
              <Input
                v-model="approvalFlowConfigurationEditForm.processName"
                style="width:300px;"
              ></Input>
            </FormItem>
          </Col>
          <Col span="12">
            <!-- 类型 -->
            <FormItem
              :label="$t('approvalFlowConfigManagement.approvalFlow.type')"
              prop="type"
            >
              <Select
                v-model="approvalFlowConfigurationEditForm.type"
                style="width:300px;"
                :placeholder="
                  $t('configuration_management.common.pleaseSelect')
                "
              >
                <Option
                  :value="item.id"
                  v-for="item in typeList"
                  v-bind:key="item.id"
                  >{{ item.name }}</Option
                >
              </Select>
            </FormItem>
          </Col>
        </Row>

        <!-- 节点 -->
        <FormItem
          :label="$t('approvalFlowConfigManagement.Node.nodeCompany')"
          prop="node"
          style="margin-bottom: 50px;"
        >
          <flow-panel ref="flowPanel"></flow-panel>
        </FormItem>
      </Form>
    </Modal>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
import FlowPanel from "@/components/ef/panel";
import ConfigurationManagementOperationLog from "../../common/ConfigurationManagementOperationLog.vue";
import { setCookie, getCookie } from "../../../../utils/cookieUtil.js";

var tableApprovalFlowConfigurationVue = {};
export default {
  components: {
    FlowPanel,
    ConfigurationManagementOperationLog
  },
  name: "TableApprovalFlowConfiguration",
  data() {
    return {
      isShowOperationLog: false,
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      approvalFlowConfigurationEditModal: false,
      loading: true,
      val: "",
      companyId: "",
      stateType: [
        this.$t("permission_configuration_management.account.disable"),
        this.$t("permission_configuration_management.account.enable")
      ],
      approvalFlowConfigurationEditForm: {
        id: "",
        processName: "",
        type: ""
      },
      typeList: [],
      name: "",
      modal_loading: false, //删除
      approvalFlowConfigurationDelmodal: false,
      approvalFlowConfigurationDetailModal: false,
      isDisable: false,
      ruleValidate: {
        processName: [
          {
            required: true,
            message: this.$t(
              "approvalFlowConfigManagement.approvalFlow.flowNameNotEmpty"
            ),
            trigger: "blur"
          },
          {
            type: "string",
            message: this.$t(
              "approvalFlowConfigManagement.approvalFlow.flowNameValidateMsg"
            ),
            pattern: "^.{4,20}$",
            trigger: "blur"
          }
        ],
        type: [
          {
            required: true,
            message: this.$t(
              "approvalFlowConfigManagement.approvalFlow.pleaseSelectType"
            ),
            trigger: "change",
            type: "number"
          }
        ]
      },
      columns: [
        {
          title: this.$t(
            "approvalFlowConfigManagement.approvalFlow.approvalFlowName"
          ),
          key: "name"
        },
        {
          title: this.$t("approvalFlowConfigManagement.approvalFlow.type"),
          key: "typeName"
        },
        {
          title: this.$t(
            "approvalFlowConfigManagement.approvalFlow.companyName"
          ),
          key: "companyName"
        },
        {
          title: this.$t("ticket.list.status"),
          key: "state",
          render: (h, params) => {
            return h("div", [
              h(
                "i-switch",
                {
                  // 数据库0禁用,1启用
                  props: {
                    type: "primary",
                    size: "large",
                    value:
                      params.row.state ==
                      this.$t(
                        "permission_configuration_management.account.enable"
                      ) // 控制开关的打开或关闭状态，官网文档属性是value
                  },
                  on: {
                    "on-change": () => {
                      this.switch(params.index);
                    }
                  }
                },
                [
                  h("span", {
                    slot: "open",
                    domProps: {
                      innerHTML: this.$t(
                        "permission_configuration_management.account.enable"
                      )
                    }
                  }),
                  h("span", {
                    slot: "close",
                    domProps: {
                      innerHTML: this.$t(
                        "permission_configuration_management.account.disable"
                      )
                    }
                  })
                ]
              )
            ]);
          }
        },
        {
          title: this.$t("common.operation"),
          slot: "detail"
        }
      ],
      tableApprovalFlowConfigurationDate: []
    };
  },
  beforeCreate: function() {
    tableApprovalFlowConfigurationVue = this;
  },
  mounted: function() {
    tableApprovalFlowConfigurationVue.getApprovalFlowConfigurationData();
  },
  methods: {
    // 查询
    search: function() {
      this.$api.processTemplate
        .processTypes("userName", getCookie(global.cookieName))
        .then(res => {
          this.typeList = res.data;
        });
    },
    showAll: function() {
      tableApprovalFlowConfigurationVue.getApprovalFlowConfigurationData();
    },
    // 分页显示数据
    /****************************************************/
    getApprovalFlowConfigurationData: function() {
      // 获取ApprovalFlowConfigurationSearch里面的搜索内容
      eventBus.$on("flowNameSearch", function(val) {
        tableApprovalFlowConfigurationVue.val = val;
      });
      eventBus.$on("companyId", function(companyId) {
        tableApprovalFlowConfigurationVue.companyId = companyId;
      });
      //分页
      this.$api.processTemplate
        .pageProcessTemplate({
          name: tableApprovalFlowConfigurationVue.val,
          companyId: tableApprovalFlowConfigurationVue.companyId,
          pageNum: this.current,
          pageSize: this.pageSize
        })
        .then(res => {
          this.tableApprovalFlowConfigurationDate = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
          // 状态
          for (
            var i = 0;
            i < this.tableApprovalFlowConfigurationDate.length;
            i++
          ) {
            this.tableApprovalFlowConfigurationDate[i].state = this.stateType[
              this.tableApprovalFlowConfigurationDate[i].state
            ];
          }
        });
    },
    changePage: function(current) {
      this.current = current;
      tableApprovalFlowConfigurationVue.getApprovalFlowConfigurationData();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableApprovalFlowConfigurationVue.getApprovalFlowConfigurationData();
    },
    // 销毁flowNameSearch
    beforeDestroy: function() {
      eventBus.$off("flowNameSearch");
    },
    // 删除
    /****************************************************/
    doDelete: function(index) {
      this.lineIndex = index;
      this.name = this.tableApprovalFlowConfigurationDate[index].name;
    },
    //编辑
    doUpdate: function(index) {
      this.lineIndex = index;
      this.$refs.flowPanel.selectProcessById(
        this.tableApprovalFlowConfigurationDate[index].id
      );
      this.approvalFlowConfigurationEditForm.id = this.tableApprovalFlowConfigurationDate[
        index
      ].id;
      this.approvalFlowConfigurationEditForm.processName = this.tableApprovalFlowConfigurationDate[
        index
      ].name;
      this.approvalFlowConfigurationEditForm.type = this.tableApprovalFlowConfigurationDate[
        index
      ].type;
      this.$api.processTemplate
        .processTypes("userName", getCookie(global.cookieName))
        .then(res => {
          this.typeList = res.data;
        });
    },
    removeApprovalFlowConfiguration: function() {
      this.isDisable = true; //开始可以点击
      var lineIndex = this.lineIndex;
      //删除
      this.$api.processTemplate
        .deleteProcessTemplate(
          "id",
          this.tableApprovalFlowConfigurationDate[lineIndex].id
        )
        .then(res => {
          this.modal_loading = true;
          setTimeout(() => {
            // 最后一页全部删除 显示前一页(当前页为最后一页，如何判断？当前页-1*每页数=总数)
            //21条  3页  2*10+1时删除
            if (
              lineIndex == 0 &&
              (this.current - 1) * this.pageSize + 1 == this.dataTotal
            ) {
              this.current = this.current - 1;
            }
            this.dataTotal = this.dataTotal - 1;
            tableApprovalFlowConfigurationVue.showAll();
            this.isDisable = false;
            this.modal_loading = false;
            this.approvalFlowConfigurationDelmodal = false;
            this.$Message.success(this.$t("common.deleteSuccess"));
          }, 1000);
        });
    },
    /**********************************启用禁用*****************************************/
    switch(index) {
      this.index = index;
      // 打开是true,0禁用 1启用
      if (
        this.tableApprovalFlowConfigurationDate[index].state ==
        this.$t("alarms.common.enable")
      ) {
        this.changeStatusMessage(
          this.tableApprovalFlowConfigurationDate[index].id,
          "state",
          0
        );
      } else {
        this.changeStatusMessage(
          this.tableApprovalFlowConfigurationDate[index].id,
          "state",
          1
        );
      }
    },
    // 更新反馈信息某一字段
    changeStatusMessage: function(id, key, value) {
      // 编辑状态
      this.$api.processTemplate
        .updateState({
          id: id,
          state: value
        })
        .then(res => {
          tableApprovalFlowConfigurationVue.getApprovalFlowConfigurationData();
        });
    },
    // 编辑审批流
    /*************************************************************************/
    // 确定
    caseSubmit: function(name) {
      this.$refs[name].validate(valid => {
        if (valid && this.$refs.flowPanel.flowNodeName.length > 0) {
          // 编辑审批流
          this.$api.processTemplate
            .updateProcessTemplate({
              id: this.approvalFlowConfigurationEditForm.id,
              name: this.approvalFlowConfigurationEditForm.processName,
              companyId: this.$refs.flowPanel.companyId,
              processNodeIds: this.$refs.flowPanel.flowNodeName,
              type: this.approvalFlowConfigurationEditForm.type
            })
            .then(res => {
              this.data = res.data;
              setTimeout(() => {
                tableApprovalFlowConfigurationVue.showAll();
                this.$refs[name].resetFields();
                this.loading = false;
                this.$nextTick(() => {
                  this.loading = true;
                });
                this.$Message.success(this.$t("common.editSuccess"));
                // 清空节点页面
                this.$refs.flowPanel.dataReload({
                  name: "",
                  nodeList: [],
                  lineList: []
                });
                // 清空公司下拉选内容
                this.$refs.flowPanel.deleteCompany();
                this.$refs.flowPanel.flowNodeName = [];
                this.$refs.flowPanel.activeElement = { type: undefined };
                this.approvalFlowConfigurationEditModal = false;
              }, 1000);
            });
        } else {
          //解决iview 表单验证，验证提示error完成验证后，"确定"按钮一直转圈，点击不起作用问题
          this.loading = false;
          setTimeout(() => {
            this.loading = true;
          }, 0);
          this.$Message.error(this.$t("common.editFail"));
        }
      });
    },
    // 取消
    caseReset: function(name) {
      this.approvalFlowConfigurationEditModal = false;
      // 清空节点页面
      this.$refs.flowPanel.dataReload({
        name: "",
        nodeList: [],
        lineList: []
      });
      // 清空公司下拉选内容
      this.$refs.flowPanel.deleteCompany();
      this.$refs.flowPanel.flowNodeName = [];
      this.$refs.flowPanel.activeElement = { type: undefined };
      this.$refs[name].resetFields();
    },
    // 操作日志
    /****************************************************/
    rowClick: function(row) {
      this.isShowOperationLog = true;
      this.$nextTick(function() {
        this.$refs.configurationManagementOperationLog.getConfigurationManagementOperationLogList(
          row.id,
          14
        );
      });
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/approval_flow_configuration/approval_flow/TableApprovalFlowConfiguration.vue